import script from "./UmbracoFormHidden.vue?vue&type=script&setup=true&lang=ts"
export * from "./UmbracoFormHidden.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__